import { useModals } from "ModalProvider";
import { IoClose } from "react-icons/io5";
import { getOriginalFileName } from "utils/string";
import Button from "./Button";
import PreviewImageModalView from "./PreviewImageModalView";

const ImagesGridView = ({
  previewTitle = "Preview",
  images,
  deleteHandler,
}) => {
  const modal = useModals();

  if (!images || images.length === 0) {
    return <div className="text-gray-500">No images</div>;
  }

  function previewImage(index) {
    modal.present({
      title: previewTitle,
      fullscreen: true,
      children: <PreviewImageModalView images={images} initialIndex={index} />,
    });
  }

  return (
    <div className="flex flex-wrap gap-4 mt-2">
      {images.map((item, index) => (
        <div
          key={index}
          className="w-full h-full flex items-center justify-center bg-gray-100 dark:bg-gray-800 rounded cursor-zoom-in hover:scale-102 duration-200 transition-all hover:shadow-md relative basis-36 grow"
        >
          <div className="relative">
            <img
              src={item.thumb || item.url}
              alt={item.url}
              className="object-contain max-h-full max-w-full"
              onClick={() => previewImage(index)}
            />

            <div className="absolute bottom-0 w-full p-2 text-white text-shadow font-semibold text-center overflow-hidden whitespace-nowrap text-ellipsis">
              {getOriginalFileName(item.url)}
            </div>
          </div>

          {deleteHandler && (
            <Button
              danger
              className="absolute top-2 right-2 text-3xl"
              onClick={() => deleteHandler(index)}
            >
              <IoClose />
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};

export default ImagesGridView;
